"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireDefault(require("react"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _underscore = require("underscore");

var _UIFlex = _interopRequireDefault(require("UIComponents/layout/UIFlex"));

var _UIBox = _interopRequireDefault(require("UIComponents/layout/UIBox"));

var _UIIcon = _interopRequireDefault(require("UIComponents/icon/UIIcon"));

var _UIButton = _interopRequireDefault(require("UIComponents/button/UIButton"));

var _UIList = _interopRequireDefault(require("UIComponents/list/UIList"));

var _colors = require("HubStyleTokens/colors");

var _DraggableContactPropertyOptionsItem = _interopRequireDefault(require("lead-flows-ui/components/editor/contactProperties/DraggableContactPropertyOptionsItem"));

var _ContactPropertyOptionDropTarget = _interopRequireDefault(require("lead-flows-ui/components/editor/contactProperties/ContactPropertyOptionDropTarget"));

var _ContactPropertyOptionsPresets = _interopRequireDefault(require("lead-flows-ui/components/editor/contactProperties/ContactPropertyOptionsPresets"));

var _ContactPropertyOption = _interopRequireDefault(require("lead-flows-ui/lib/ContactPropertyOption"));

var _ArrayUtils = require("lead-flows-ui/utils/ArrayUtils");

var _Logger = _interopRequireDefault(require("lead-flows-ui/lib/Logger"));

var newLinePattern = /[\r\n]+/g;
var commaPattern = /\s*,\s*/;
var tabPattern = /\s*\t\s*/;

function parseFromLine(line, index) {
  var colDivider = line.indexOf('\t') > -1 ? tabPattern : commaPattern;

  var _line$split = line.split(colDivider),
      _line$split2 = (0, _slicedToArray2.default)(_line$split, 2),
      label = _line$split2[0],
      value = _line$split2[1];

  return new _ContactPropertyOption.default({
    label: label,
    value: value || label,
    cid: (0, _underscore.uniqueId)(),
    displayOrder: index
  });
}

function parseFromText(textValue, insertIndex, options) {
  var lines = textValue.split(newLinePattern);
  var propertyOptions = lines.map(function (value, index) {
    return parseFromLine(value, index);
  });
  return [].concat((0, _toConsumableArray2.default)(options), (0, _toConsumableArray2.default)(propertyOptions)).filter(function (_ref) {
    var value = _ref.value;
    return !(0, _underscore.isEmpty)(value);
  });
}

var ContactPropertyOptions =
/*#__PURE__*/
function (_React$PureComponent) {
  (0, _inherits2.default)(ContactPropertyOptions, _React$PureComponent);
  (0, _createClass2.default)(ContactPropertyOptions, null, [{
    key: "propTypes",
    get: function get() {
      return {
        handleChange: _react.default.PropTypes.func.isRequired,
        handleBlur: _react.default.PropTypes.func.isRequired,
        options: _react.default.PropTypes.array.isRequired,
        errorMessage: _react.default.PropTypes.string.isRequired,
        errorSubject: _react.default.PropTypes.string.isRequired
      };
    }
  }]);

  function ContactPropertyOptions() {
    var _this;

    (0, _classCallCheck2.default)(this, ContactPropertyOptions);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(ContactPropertyOptions).call(this));
    _this.handleOptionsClear = _this.handleOptionsClear.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleOptionChange = _this.handleOptionChange.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleOptionDelete = _this.handleOptionDelete.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleOptionReorder = _this.handleOptionReorder.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleOptionPaste = _this.handleOptionPaste.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleNewOption = _this.handleNewOption.bind((0, _assertThisInitialized2.default)(_this));
    _this.setOptions = _this.setOptions.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(ContactPropertyOptions, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      var defaultOptions = this.addDefaultOptionsIfNeeded([]);
      this.setOptions(defaultOptions);
    }
  }, {
    key: "getLangKey",
    value: function getLangKey(path) {
      return "leadFlowEditor.contactProperties.createNew." + path;
    }
  }, {
    key: "handleOptionsClear",
    value: function handleOptionsClear() {
      var options = this.props.options;

      if (options.length !== 1 || options[0].value !== '') {
        // Clear only if not already in default state
        this.setOptions(this.addDefaultOptionsIfNeeded([]));
      }
    }
  }, {
    key: "handleOptionChange",
    value: function handleOptionChange(index, _ref2) {
      var value = _ref2.target.value;
      var options = this.props.options;
      var newOptions = (0, _ArrayUtils.updateItemInArray)(options, index, Object.assign({}, options[index], {
        label: value,
        value: value
      }));
      this.setOptions(newOptions);
    }
  }, {
    key: "handleOptionDelete",
    value: function handleOptionDelete(index) {
      var options = this.props.options;
      var newOptions;

      if (options.length !== 1 || options[0].value !== '') {
        // Delete only if not already in default state
        newOptions = (0, _ArrayUtils.removeItemFromArray)(options, index);
        newOptions = this.addDefaultOptionsIfNeeded(newOptions);
        this.setOptions(newOptions);
      }
    }
  }, {
    key: "handleOptionReorder",
    value: function handleOptionReorder(draggedOptionId, targetIndex) {
      var options = this.props.options;
      var draggedOption = options.filter(function (option) {
        return option.cid === draggedOptionId;
      });
      var otherOptions = options.filter(function (option) {
        return option.cid !== draggedOptionId;
      });
      var newOptions = (0, _ArrayUtils.addItemToArray)(otherOptions, targetIndex, draggedOption[0]).map(function (option, index) {
        return Object.assign({}, option, {
          displayOrder: index
        });
      });
      this.setOptions(newOptions);
    }
  }, {
    key: "handleNewOption",
    value: function handleNewOption() {
      var options = this.props.options;

      if ((0, _underscore.any)(options, function (option) {
        return (0, _underscore.isEmpty)(option.value);
      })) {
        return;
      }

      this.setOptions(options.concat([new _ContactPropertyOption.default({
        cid: (0, _underscore.uniqueId)(),
        displayOrder: options.length
      })]).map(function (option, index) {
        return Object.assign({}, option, {
          displayOrder: index
        });
      }));
    }
  }, {
    key: "handleOptionPaste",
    value: function handleOptionPaste(index, evt) {
      var options = this.props.options;

      try {
        var pasteValue = evt.clipboardData.getData('text/plain');

        if (!pasteValue.match(/[\n\t\r,]/)) {
          return;
        }

        evt.preventDefault();
        var newOptions = parseFromText(pasteValue, index, options);
        this.setOptions(newOptions);
      } catch (e) {
        _Logger.default.error(e);
      }
    }
  }, {
    key: "setOptions",
    value: function setOptions(newOptions) {
      this.props.handleChange(newOptions);
    }
  }, {
    key: "addDefaultOptionsIfNeeded",
    value: function addDefaultOptionsIfNeeded(options) {
      if (options.length === 0) {
        // Add a default state, with one empty option field
        return [new _ContactPropertyOption.default({
          cid: (0, _underscore.uniqueId)(),
          displayOrder: options.length
        })];
      }

      return options;
    }
  }, {
    key: "renderOptions",
    value: function renderOptions(options) {
      var _this2 = this;

      var _this$props = this.props,
          errorMessage = _this$props.errorMessage,
          errorSubject = _this$props.errorSubject;
      return options.map(function (option, index) {
        return _react.default.createElement(_UIFlex.default, {
          key: option.cid,
          direction: "column"
        }, _react.default.createElement(_UIBox.default, {
          className: "contact-property-option-container"
        }, _react.default.createElement(_ContactPropertyOptionDropTarget.default, {
          index: index,
          handleOptionReorder: _this2.handleOptionReorder
        })), _react.default.createElement(_UIBox.default, {
          className: "contact-property-option-container"
        }, _react.default.createElement(_DraggableContactPropertyOptionsItem.default, {
          index: index,
          option: option,
          handleChange: function handleChange(e) {
            return _this2.handleOptionChange(index, e);
          },
          handleDelete: function handleDelete(e) {
            return _this2.handleOptionDelete(index, e);
          },
          handlePaste: function handlePaste(e) {
            return _this2.handleOptionPaste(index, e);
          },
          handleReorder: _this2.handleOptionReorder,
          handleBlur: _this2.props.handleBlur,
          errorMessage: errorSubject.indexOf(option.value) !== -1 ? errorMessage : ''
        })));
      }).concat([_react.default.createElement(_UIFlex.default, {
        key: "last target"
      }, _react.default.createElement(_UIBox.default, {
        className: "contact-property-option-container"
      }, _react.default.createElement(_ContactPropertyOptionDropTarget.default, {
        index: options.length,
        handleOptionReorder: this.handleOptionReorder
      })))]);
    }
  }, {
    key: "renderControls",
    value: function renderControls(options) {
      return _react.default.createElement(_UIList.default, {
        inline: true
      }, _react.default.createElement(_UIButton.default, {
        use: "link",
        onClick: this.handleNewOption
      }, _react.default.createElement(_UIIcon.default, {
        className: "m-right-1",
        name: "add"
      }), _react.default.createElement(_FormattedMessage.default, {
        message: this.getLangKey('add')
      })), this.renderLoadOptions(options), this.renderClear(options));
    }
  }, {
    key: "renderLoadOptions",
    value: function renderLoadOptions(options) {
      return _react.default.createElement(_ContactPropertyOptionsPresets.default, {
        handleUpdateOptions: this.setOptions,
        options: options
      });
    }
  }, {
    key: "renderClear",
    value: function renderClear(options) {
      if ((0, _underscore.isEmpty)(options)) {
        return null;
      }

      return _react.default.createElement(_UIButton.default, {
        onClick: this.handleOptionsClear,
        use: "link"
      }, _react.default.createElement(_UIIcon.default, {
        name: "delete",
        color: _colors.CALYPSO,
        className: "m-right-1"
      }), _react.default.createElement(_FormattedMessage.default, {
        message: this.getLangKey('clear')
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var options = this.props.options;
      var optionComponents = this.renderOptions(options);
      return _react.default.createElement("div", null, _react.default.createElement(_UIList.default, {
        className: "p-bottom-1"
      }, optionComponents), this.renderControls(options));
    }
  }], [{
    key: "defaultProps",
    get: function get() {
      return {
        errorSubject: ''
      };
    }
  }]);
  return ContactPropertyOptions;
}(_react.default.PureComponent);

exports.default = ContactPropertyOptions;
module.exports = exports.default;